import { defineMessages } from 'react-intl';

export const webhookEndpointsMessages = defineMessages({
    systemSettings: {
        id: 'system-settings',
        defaultMessage: 'System settings',
    },
    webhookEndpoints: {
        id: 'webhook-endpoints',
        defaultMessage: 'Webhooks',
    },
    webhook: {
        id: 'webhook',
        defaultMessage: 'Webhook',
    },
    webhooks: {
        id: 'webhooks',
        defaultMessage: 'Webhooks',
    },
    url: {
        id: 'url',
        defaultMessage: 'URL',
    },
    topics: {
        id: 'topics',
        defaultMessage: 'Topics',
    },
    secret: {
        id: 'secret',
        defaultMessage: 'Secret',
    },
    createWebhookEndpointSuccess: {
        id: 'create-webhook-endpoint-success',
        defaultMessage: 'Webhook created',
    },
    createWebhookEndpointSuccessDescription: {
        id: 'create-webhook-endpoint-success-description',
        defaultMessage: 'The webhook has been successfully created.',
    },
    addWebhookEndpointSubtitle: {
        id: 'add-webhook-endpoint-subtitle',
        defaultMessage: 'Create a new webhook',
    },
    deleteWebhookEndpoint: {
        id: 'delete-webhook-endpoint',
        defaultMessage: 'Delete webhook',
    },
    deleteWebhookEndpointSuccess: {
        id: 'delete-webhook-endpoint-success',
        defaultMessage: 'Webhook deleted',
    },
    deleteWebhookEndpointSuccessDescription: {
        id: 'delete-webhook-endpoint-success-description',
        defaultMessage: 'The webhook has been successfully deleted.',
    },
    confirmDeleteWebhookEndpoint: {
        id: 'confirm-delete-webhook-endpoint',
        defaultMessage: 'Are you sure you want to delete this webhook? This action cannot be undone.',
    },
    deleteWebhookEndpointSubtitle: {
        id: 'delete-webhook-endpoint-subtitle',
        defaultMessage: 'Permanently delete webhook',
    },
    editWebhookEndpointSubtitle: {
        id: 'edit-webhook-endpoint-subtitle',
        defaultMessage: 'Edit webhook',
    },
    updateWebhookEndpointSuccess: {
        id: 'update-webhook-endpoint-success',
        defaultMessage: 'Webhook updated',
    },
    updateWebhookEndpointSuccessDescription: {
        id: 'update-webhook-endpoint-success-description',
        defaultMessage: 'Webhook has been successfully updated.',
    },
    rotate: {
        id: 'rotate',
        defaultMessage: 'Rotate',
    },
    rotateSecret: {
        id: 'rotate-secret',
        defaultMessage: 'Rotate secret',
    },
    rotateWebhookEndpointSecretSuccessDescription: {
        id: 'rotate-webhook-endpoint-secret-success-description',
        defaultMessage: 'The webhook secret has been successfully rotated.',
    },
    confirmRotateWebhookEndpointSecret: {
        id: 'confirm-rotate-webhook-endpoint-secret',
        defaultMessage: 'Are you sure you want to rotate the webhook secret? This action cannot be undone.',
    },
    rotateWebhookEndpointSecretSubtitle: {
        id: 'rotate-webhook-endpoint-secret-subtitle',
        defaultMessage: 'Rotate webhook secret',
    },
    rotateWebhookEndpointSecretSuccess: {
        id: 'rotate-webhook-endpoint-secret-success',
        defaultMessage: 'Secret rotated',
    },
});
